// Logic constants to replace magic numbers
export const PAGINATION_LOGIC = {
  MOBILE_RANGE: 1,
  DESKTOP_RANGE: 4,
  ELLIPSIS_THRESHOLD_MOBILE: 1,
  ELLIPSIS_THRESHOLD_DESKTOP: 2,
  DEFAULT_PAGE: 1,
} as const;
